<template>
  <v-dialog v-model="open" persistent transition="dialog-bottom-transition" width="540px" class="contract-modal">
    <v-card class="contract-modal__card">
      <v-toolbar color="primary" flat class="contract-modal__toolbar">
        <v-toolbar-title class="contract-modal__title white--text">
          {{ currentContract.id_doc 
              ? (selectedTemplate ? selectedTemplate.templateName : getProposalTypeLabel(currentContract.selectedProposalType))
              : currentContract.selectedTemplateId && currentContract.selectedProposalId && selectedTemplate
                ? selectedTemplate.templateName
                : "Novo Contrato" 
          }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="contract-modal__actions">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn icon class="contract-modal__action-btn" v-on="on" style="background: transparent; color: white;">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="isAdminOrSuperAdmin" @click="openContractGenerationModal">
                <v-list-item-icon>
                  <v-icon>mdi-file-document-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Gerar Contrato</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="currentContract && currentContract.historic && currentContract.historic.length" @click="showHistory">
                <v-list-item-icon>
                  <v-icon>mdi-history</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Histórico</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="isAdminOrSuperAdmin">
                <v-list-item-icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Enviar para Assinatura</v-list-item-title>
              </v-list-item>
              <v-list-item  @click="close">
                <v-list-item-icon>
                  <v-icon>mdi-close</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Fechar</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-toolbar>

      <div class="contract-modal__wrapper">
        <div v-if="isContentLoading" class="contract-modal__loading-overlay">
          <v-progress-circular
            indeterminate
            color="primary"
            size="64"
          ></v-progress-circular>
        </div>

        <v-card-text v-show="!isContentLoading" class="contract-modal__content pa-6">
          <div class="contract-modal__section">
            <h2 class="text-h5 mb-4">Contrato Anexado</h2>
            <div v-if="!currentContract.selectedTemplateId || !currentContract.selectedProposalId" class="text-center pa-4 mb-4">
              <v-icon large color="warning" class="mb-2">mdi-alert</v-icon>
              <p class="text-subtitle-1">É necessário gerar um contrato antes de prosseguir.</p>
              <v-btn v-if="isAdminOrSuperAdmin" color="primary" class="mt-2" @click="openContractGenerationModal">
                <v-icon left>mdi-file-document-edit</v-icon>
                Gerar Contrato
              </v-btn>
            </div>
            <div v-else>
              <div v-if="selectedTemplate" class="mb-4">
                <div class="d-flex align-center mb-2">
                  <v-icon color="info" class="mr-2">mdi-file-document-outline</v-icon>
                  <span>Tipo de Proposta: {{ getProposalTypeLabel(currentContract.selectedProposalType) }}</span>
                </div>
                <div class="d-flex align-center">
                  <v-icon color="info" class="mr-2">mdi-file-document-edit</v-icon>
                  <span>Nome do Template: {{ selectedTemplate.templateName }}</span>
                </div>
              </div>
             
              <div class="contract-modal__upload-section">
                <InputFiles
                  :fileTypes="fileTypes"
                  :showFile="fileToShow"
                  titleName="Anexar Contrato"
                  @change:file="(file) => fileToShow = file"
                  :disabled="!isAdminOrSuperAdmin"
                />
                <div v-if="!isAdminOrSuperAdmin && fileToShow" class="mt-2 text-center">
                  <span class="caption grey--text text--darken-2">
                    Apenas administradores podem modificar contratos.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <v-btn 
            v-if="fileToShow" 
            color="primary" 
            class="mb-4"
            width="100%"
            @click="downloadFile"
          >
          Baixar Arquivo
          <v-icon right>mdi-download</v-icon>
          </v-btn>
        </v-card-text>

        <v-divider v-show="!isContentLoading"></v-divider>

        <v-card-actions v-show="!isContentLoading">
          <v-spacer></v-spacer>
          <v-btn  
          color="blue darken-1" 
          text
          @click="close" >
            Cancelar
          </v-btn>
          <v-btn
            color="blue darken-1" 
            text
            v-if="isAdminOrSuperAdmin"
            :disabled="!fileToShow || !currentContract.selectedTemplateId || !currentContract.selectedProposalId"
            @click="saveContract"
          >
          {{ isUpdateMode ? 'Atualizar' : 'Salvar Novo' }}
            <v-icon right>{{ isUpdateMode ? 'mdi-content-save' : 'mdi-plus' }}</v-icon>
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>

    <v-dialog v-model="dialogDownload" max-width="400">
                  <v-card class="download-dialog">
                  <v-card-title class="headline d-flex align-center">
                    <v-icon color="primary" class="mr-2">mdi-download</v-icon>
                    Salvar Arquivo
                  </v-card-title>
                  <v-card-text class="pt-4">
                    <p class="text-body-1">
                      O arquivo está pronto para ser baixado. Clique no botão abaixo para salvá-lo em seu computador.
                    </p>
                    <v-alert
                      type="info"
                      variant="tonal"
                      class="mt-3"
                      icon="mdi-information"
                    >
                      Após o download, esta janela fechará automaticamente.
                    </v-alert>
                  </v-card-text>
                  <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <a :href="fileLink" download :download="fileToShow && fileToShow.name || 'contrato'" class="text-decoration-none">
                      <v-btn
                        color="primary"
                        variant="elevated"
                        prepend-icon="mdi-download"
                        @click="dialogDownload = false"
                      >
                        Salvar Arquivo
                      </v-btn>
                    </a>
                    <v-btn
                      color="white"
                      variant="text"
                      class="ml-2"
                      @click="dialogDownload = false"
                    >
                      Fechar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

    <v-dialog v-model="isLoading" max-width="320" persistent class="contract-modal__loading-dialog">
      <v-card class="pa-4">
        <div class="d-flex align-center">
          <span class="text-subtitle-1 mr-4">{{isLoadingMessage}}</span>
          <v-progress-circular color="primary" indeterminate size="32" width="2"></v-progress-circular>
        </div>
      </v-card>
    </v-dialog>

    <ContractHistoryModal
      v-if="currentContract && currentContract.historic && currentContract.historic.length"
      :open="historyModalOpen"
      :contract="currentContract"
      :close="closeHistoryModal"
    />
  </v-dialog>
</template>

<script>
import NewContractModalScript from "./NewContractModalScript";
import ContractHistoryModal from './ContractHistoryModal.vue';

export default NewContractModalScript;

</script>

<style lang="scss" scoped>
.contract-modal {
  &__card {
    border-radius: 8px;
    overflow: hidden;
  }

  &__toolbar {
    position: sticky;
    top: 0;
    z-index: 10;
  }

  &__close-btn {
    margin-left: -12px;
  }

  &__title {
    font-size: 1.25rem;
    font-weight: 500;
  }

  &__actions {
    display: flex;
    gap: 12px;
  }

  &__action-btn {
    text-transform: none;
    letter-spacing: 0.5px;
  }

  &__content {
    background-color: #FFF;
  }

  &__section {
    max-width: 800px;
    margin: 0 auto;
  }

  &__upload-section {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
  }

  &__footer {
    background-color: #f5f5f5;
  }

  &__save-btn {
    text-transform: none;
    letter-spacing: 0.5px;
    min-width: 180px;
  }

  &__loading-dialog {
    .v-card {
      border-radius: 8px;
    }
  }

  &__wrapper {
    position: relative;
    min-height: 300px;
  }

  &__loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5;
  }
}
</style>
